import { render } from "./PendingIssues.vue?vue&type=template&id=4a3dd445"
import script from "./PendingIssues.vue?vue&type=script&lang=js"
export * from "./PendingIssues.vue?vue&type=script&lang=js"

import "./PendingIssues.vue?vue&type=style&index=0&id=4a3dd445&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__